// extracted by mini-css-extract-plugin
module.exports = {"paper":"BasicChart_paper__1YuGn","header":"BasicChart_header__1nszs","dialogcontainer":"BasicChart_dialogcontainer__30-QC","nostats":"BasicChart_nostats__3tUZe"};